// extracted by mini-css-extract-plugin
export default {"label":"TabCinque_label__o2t1m","labelDisabled":"TabCinque_labelDisabled__ArSiA","textFieldDisabled":"TabCinque_textFieldDisabled__Upjur"};